import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmergencyContactCard = ({ contact }) => {
  const handleCall = (number) => {
    window.location.href = `tel:${number}`;
  };

  const handleEmail = (email) => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation">
      <div className="flex items-start gap-4 mb-4">
        <div className="bg-error/10 p-3 rounded-lg">
          <Icon name={contact?.icon} size={24} className="text-error" />
        </div>
        <div className="flex-1">
          <h3 className="text-card-foreground font-semibold text-lg mb-1">{contact?.title}</h3>
          <p className="text-muted-foreground text-sm">{contact?.description}</p>
        </div>
      </div>
      <div className="space-y-3">
        {contact?.phone && (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Icon name="Phone" size={18} className="text-muted-foreground" />
              <span className="text-card-foreground">{contact?.phone}</span>
            </div>
            <Button
              variant="outline"
              size="sm"
              iconName="Phone"
              onClick={() => handleCall(contact?.phone)}
            >
              Call
            </Button>
          </div>
        )}
        
        {contact?.email && (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Icon name="Mail" size={18} className="text-muted-foreground" />
              <span className="text-card-foreground text-sm">{contact?.email}</span>
            </div>
            <Button
              variant="outline"
              size="sm"
              iconName="Mail"
              onClick={() => handleEmail(contact?.email)}
            >
              Email
            </Button>
          </div>
        )}
        
        {contact?.available24x7 && (
          <div className="flex items-center gap-2 text-success text-sm">
            <Icon name="Clock" size={16} />
            <span>Available 24/7</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmergencyContactCard;